import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { Nullable } from "@/types";

export type ItemListPaths = {
    wishlistAddPath: Nullable<string>;
    wishlistRemovePath: Nullable<string>;
    wishlistListPath: Nullable<string>;
    pinnedCollectionAddPath: Nullable<string>;
    pinnedCollectionRemovePath: Nullable<string>;
};

type State = ItemListPaths & {
    isOnWishlist: boolean;
};

const initialState: State = {
    wishlistAddPath: null,
    wishlistRemovePath: null,
    wishlistListPath: null,
    pinnedCollectionAddPath: null,
    pinnedCollectionRemovePath: null,
    isOnWishlist: false,
};

const slice = createSlice({
    name: "itemList",
    initialState,
    reducers: {
        itemListSetPathsAction: (state: State, action: PayloadAction<ItemListPaths>) => {
            state.wishlistAddPath = action.payload.wishlistAddPath;
            state.wishlistRemovePath = action.payload.wishlistRemovePath;
            state.wishlistListPath = action.payload.wishlistListPath;
            state.pinnedCollectionAddPath = action.payload.pinnedCollectionAddPath;
            state.pinnedCollectionRemovePath = action.payload.pinnedCollectionRemovePath;
        },
        itemListSetWishlistStatusAction: (state: State, action: PayloadAction<boolean>) => {
            state.isOnWishlist = action.payload;
        },
    },
});

export const { itemListSetPathsAction, itemListSetWishlistStatusAction } = slice.actions;
export default slice.reducer;
